// extracted by mini-css-extract-plugin
export default {"title":"_8ffbfa7a7e","bld":"_9a4933c76a"};